import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import * as Sentry from "@sentry/browser";
import MAPPING from "notifications/mapping";
import NotificationCheckbox from "notifications/containers/checkbox";
import TimeWithTooltip from "common/components/time_with_tooltip";
import { getNotificationComponent } from "notifications/utils";

export default class NotificationWrapper extends Component {
  constructor(props) {
    super(props);
    this.read = this.read.bind(this);
    this.clear = this.clear.bind(this);
  }

  componentDidMount() {
    const { notification } = this.props;

    if (
      !getNotificationComponent(
        MAPPING[notification.n_id],
        notification.showGrouped
      )
    ) {
      /* report missing notification to Sentry */
      Sentry.withScope(() => {
        Sentry.captureMessage(
          `Missing onsite notification ID ${notification.n_id}`,
          "error"
        );
      });
    }
  }

  read() {
    const { notification, userId, read } = this.props;
    if (!notification.read) {
      read(userId, notification.uuid);
    }
  }

  clear(e) {
    const { notification, userId, clear } = this.props;
    e.stopPropagation();
    clear(userId, notification.uuid);
  }

  render() {
    const { notification, showChecks, showClear } = this.props;
    const { n_id, read, context, datetime, showGrouped } = notification;
    const NotificationComponent = getNotificationComponent(
      MAPPING[n_id],
      showGrouped
    );
    const notifClass = classnames("notification", { read });

    return (
      <div className={classnames({ row: showChecks })}>
        {showChecks && (
          <div className="medium-2 large-1 columns hide-for-small-only">
            <NotificationCheckbox notificationId={notification.uuid} />
          </div>
        )}
        <div
          className={classnames({
            "small-16 medium-14 large-15 columns": showChecks,
          })}
        >
          <div className={notifClass} onClick={this.read}>
            <div className="row">
              <div className="small-16 columns">
                {showClear && (
                  <i
                    className="clear-notification fa-solid fa-xmark"
                    onClick={this.clear}
                  />
                )}

                <div className="notification-date">
                  <TimeWithTooltip time={datetime} />
                </div>
              </div>
            </div>
            {NotificationComponent ? (
              <NotificationComponent {...context} />
            ) : (
              <div>Component for Notification {n_id} not yet implemented</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

NotificationWrapper.propTypes = {
  notification: PropTypes.shape({
    n_id: PropTypes.number,
    read: PropTypes.bool,
    context: PropTypes.object,
    uuid: PropTypes.string,
    datetime: PropTypes.string,
    showGrouped: PropTypes.bool,
  }),
  userId: PropTypes.number,
  read: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  showChecks: PropTypes.bool,
  showClear: PropTypes.bool,
};
